// extracted by mini-css-extract-plugin
export var bgBrandBlack = "BgColor-module--bgBrandBlack--4ed3e";
export var bgBrandGreyWarmDark = "BgColor-module--bgBrandGreyWarmDark--7df04";
export var bgBrandGreyWarmLight = "BgColor-module--bgBrandGreyWarmLight--b551d";
export var bgBrandRed = "BgColor-module--bgBrandRed--6a159";
export var bgBrandWhite = "BgColor-module--bgBrandWhite--60d42";
export var bgSemiTransparent = "BgColor-module--bgSemiTransparent--05bf9";
export var bgTransparent = "BgColor-module--bgTransparent--cb8c6";